module.exports = __webpack_public_path__ + "static/img/Nodata.d120735e.png";